import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './messages/en.json'
import ru from './messages/ru.json'
import az from './messages/az.json'

import config from '@/config/default'

Vue.use(VueI18n)

const locale = config.locale

let messages = {}
const suite = {
  en: en,
  ru: ru,
  az: az
}
for (let i in config.locales) {
  messages[config.locales[i]] = suite[config.locales[i]]
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js